import { render, staticRenderFns } from "./app-bard.vue?vue&type=template&id=db58e392&scoped=true"
import script from "./app-bard.vue?vue&type=script&lang=js"
export * from "./app-bard.vue?vue&type=script&lang=js"
import style0 from "./app-bard.vue?vue&type=style&index=0&id=db58e392&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db58e392",
  null
  
)

export default component.exports